import { render, staticRenderFns } from "./ElYtShorts.vue?vue&type=template&id=7832f5fe"
import script from "./ElYtShorts.vue?vue&type=script&lang=js"
export * from "./ElYtShorts.vue?vue&type=script&lang=js"
import style0 from "./ElYtShorts.vue?vue&type=style&index=0&id=7832f5fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports